import {Injectable} from '@angular/core';
// tslint:disable:no-string-literal
import {Camera, ChooseFromGalleryOptions, TakePhotoOptions} from '@capacitor/camera';
import {Filesystem} from '@capacitor/filesystem';
import {Position} from '@capacitor/geolocation';
import {TranslateService} from '@ngx-translate/core';
import {firstValueFrom} from 'rxjs';


export class Photo {
    dataUrl: string;
    exif: any;
    format: string;
    saved?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class CameraService {

    cameraOptions: TakePhotoOptions = {
        quality: 90,
        correctOrientation: true,
        editable: 'no',
        includeMetadata: true,
    };

    filesystemOptions: ChooseFromGalleryOptions = {
        quality: 90,
        editable: 'no',
        correctOrientation: true,
        allowMultipleSelection: false,
        limit: 1,
        includeMetadata: true
        // resultType: CameraResultType.DataUrl, // Base64/Uri/DataUrl
    };

    constructor(
        private translate: TranslateService
    ) {
    }

    async getFromFileSystem(): Promise<Photo> {
        const { results } = await Camera.chooseFromGallery(this.filesystemOptions);

        const { data } = await Filesystem.readFile({ path: results[0].uri });
        const dataUrl = `data:image/${results[0].metadata.format};base64,${data}`;

        const image: Photo = {
            dataUrl: dataUrl,
            exif: results[0].metadata.exif,
            format: results[0].metadata.format,
        };
        return image;
    }

    async getGeocodedPicture(position: Position): Promise<Photo> {
        console.log('position: ', position.coords);

        const result = await Camera.takePhoto(this.cameraOptions);
        const { data } = await Filesystem.readFile({ path: result.uri });
        const dataUrl = `data:image/${result.metadata.format};base64,${data}`;

        const image: Photo = {
            dataUrl: dataUrl,
            exif: result.metadata.exif,
            format: result.metadata.format,
        };

        console.log('exif: ', image.exif);
        if (!image.exif['GPSLatitude']) {
            image.exif['GPSLatitude'] = position.coords.latitude;
            image.exif['GPSLatitudeRef'] = 'N';
        }
        if (!image.exif['GPSLongitude']) {
            image.exif['GPSLongitude'] = position.coords.longitude;
            image.exif['GPSLongitudeRef'] = 'E';
        }
        if (!image.exif['GPSAltitude']) {
            image.exif['GPSAltitude'] = position.coords.altitude;
            image.exif['GPSAltitudeRef'] = '0';
        }
        if (!image.exif['GPSDOP']) {
            image.exif['GPSDOP'] = position.coords.accuracy;
        }
        return image;
    }

    async validatePicture(photo: Photo): Promise<boolean> {
        const doValidate = async () => {
            if (photo.exif.imageHeight < 512) {
                return firstValueFrom(this.translate.get('services.camera.error-height-too-small'));
            }
            if (photo.exif.imageWidth < 512) {
                return firstValueFrom(this.translate.get('services.camera.error-width-too-small'));
            }
            return true;
        };

        return new Promise(async (resolve, reject) => {
            if (photo.format !== 'jpeg' && photo.format !== 'jpg') {
                const message = await firstValueFrom(this.translate.get('services.camera.error-invalid-format'));
                reject(message);
            }

            let result: any;
            // intentional or mistake??
            if (photo.exif && (photo.exif.imageWidth && photo.exif.ImageWidth) && (photo.exif.imageHeight || photo.exif.ImageHeight || photo.exif.ImageLength)) {
                if (!photo.exif.imageHeight) {
                    photo.exif.imageHeight = photo.exif.ImageHeight ? parseInt(photo.exif.ImageHeight, 10) : parseInt(photo.exif.ImageLength, 10);
                }
                if (!photo.exif.imageWidth) {
                    photo.exif.imageWidth = parseInt(photo.exif.ImageWidth, 10);
                }
                console.log('Calling doValidate', photo.exif);
                result = await doValidate();
                if (result === true) {
                    resolve(true);
                } else {
                    reject(result);
                }
            } else {
                const oldImage = document.querySelector('img#tempImage');
                if (oldImage) {
                    oldImage.remove();
                }
                const image: HTMLImageElement = document.createElement('img');
                image.style.position = 'absolute';
                image.id = 'tempImage';
                image.onload = async () => {
                    photo.exif.imageHeight = image.naturalHeight;
                    photo.exif.imageWidth = image.naturalWidth;

                    result = await doValidate();
                    if (result === true) {
                        resolve(true);
                    } else {
                        reject(result);
                    }

                    image.remove();
                };
                image.onerror = (error) => {
                    console.log('Error loading image', error);
                }
                image.src = photo.dataUrl;
            }
        });
    }
}
